export function removeEmptyPropsFromObject(object) {
  return Object.keys(object).forEach(
    key =>
      (object[key] === undefined ||
        object[key] === null ||
        object[key] === "") &&
      delete object[key]
  );
}
